/* eslint-disable
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import CharPickerData from 'char-picker-data';
import PropTypes from 'prop-types';

import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import CharListing, {COMMON_SYMBOLS} from 'notebook/mediocre/symbols/CharListing';
import CharPreview from 'notebook/mediocre/symbols/CharPreview';
import UniCloud from 'notebook/mediocre/symbols/UniCloud';
import {debounce} from 'ts-debounce';

const CHAR_PICKER_DATA = new CharPickerData();
const INITIAL_CATEGORY = 0;
const INITIAL_SUBCATEGORY = CharListing.COMMON_SYMBOLS_SUBCATEGORY;

function sortSearchResults(results) {
  return _.sortBy(results, (result) => (COMMON_SYMBOLS.includes(result) ? -1 : 1));
}

class FullCharPreview extends React.PureComponent {
  static propTypes = {
    char: PropTypes.string.isRequired,
  };

  render() {
    return (
      <UniCloud char={this.props.char}>
        {({name, codePoint}) => (
          <div className="fullCharPreview u-small-spacing-top u-small-padding">
            <div className="fullCharPreview-char selectable">
              {CharPreview.previewableChar(this.props.char)}
            </div>
            <div>{name || '\u00A0'}</div>
            <div className="u-small-text faded">{codePoint}</div>
          </div>
        )}
      </UniCloud>
    );
  }
}

class UnicodeCharacterChooser extends React.PureComponent {
  static propTypes = {
    char: PropTypes.string,
    selectChar: PropTypes.func.isRequired,
  };

  state = {
    searchQuery: '',
    searchResults: [],
    category: INITIAL_CATEGORY,
    subCategory: INITIAL_SUBCATEGORY,
  };

  performSearch = debounce((searchQuery) => {
    if (this._isMounted && searchQuery.length === 0) {
      this.clearSearch();
      return;
    }
    UniCloud.searchChars(searchQuery)
      .catch(() => {
        notifications.error('An error occurred while searching.', {id: 'unicode-character-chooser'});
        return [];
      })
      .then((results) => {
        if (this._isMounted && this.state.searchQuery === searchQuery) {
          const searchResults = sortSearchResults(results);
          this.setState({searchResults}, () => {
            if (searchResults.length === 0) {
              return;
            }
            const char = searchResults[0];
            this.props.selectChar({char, insert: false});
          });
        }
      });
  }, 100);

  handleQueryChange = (e) => {
    const searchQuery = e.target.value;
    this.setState({searchQuery});
    this.performSearch(searchQuery);
  };

  handleCategoryChange = (e) => {
    const category = parseInt(e.target.value, 10);
    const newSubCategory = category === 0 ? CharListing.COMMON_SYMBOLS_SUBCATEGORY : 0;
    this.setState({category, subCategory: newSubCategory});
  };

  handleSubCategoryChange = (e) => {
    const subCategory = parseInt(e.target.value, 10);
    this.setState({subCategory});
  };

  clearSearch = () => {
    this.setState({searchQuery: '', searchResults: []});
  };

  componentDidMount() {
    this._isMounted = true;
    return _.defer(() => {
      if (this._isMounted) {
        ReactDOM.findDOMNode(this.refs.searchInput).focus();
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let category, subCategory;
    return (
      <div>
        <Row>
          <Col sm={7}>
            <div>
              {this.state.searchQuery.length ? (
                <a onClick={this.clearSearch} className="u-input-line-height">
                  Clear search
                </a>
              ) : (
                [
                  <select
                    key="select-category"
                    className="u-inline-form-input-sm"
                    value={this.state.category}
                    onChange={this.handleCategoryChange}
                  >
                    {(() => {
                      const result = [];
                      for (category = 0; category < CHAR_PICKER_DATA.categories.length; category++) {
                        const categoryName = CHAR_PICKER_DATA.categories[category];
                        result.push(
                          <option key={category} value={category}>
                            {categoryName}
                          </option>
                        );
                      }
                      return result;
                    })()}
                  </select>,
                  <select
                    key="select-subcategory"
                    className="u-inline-form-input u-small-spacing-left"
                    value={this.state.subCategory}
                    onChange={this.handleSubCategoryChange}
                  >
                    {this.state.category === 0 ? (
                      <option
                        key={CharListing.COMMON_SYMBOLS_SUBCATEGORY}
                        value={CharListing.COMMON_SYMBOLS_SUBCATEGORY}
                      >
                        Common Symbols
                      </option>
                    ) : undefined}
                    {(() => {
                      const result1 = [];
                      for (
                        subCategory = 0;
                        subCategory < CHAR_PICKER_DATA.subcategories[this.state.category].length;
                        subCategory++
                      ) {
                        const subCategoryName =
                          CHAR_PICKER_DATA.subcategories[this.state.category][subCategory];
                        result1.push(
                          <option key={subCategory} value={subCategory}>
                            {subCategoryName}
                          </option>
                        );
                      }
                      return result1;
                    })()}
                  </select>,
                ]
              )}
            </div>
            <CharListing
              charPickerData={CHAR_PICKER_DATA}
              searchQuery={this.state.searchQuery}
              searchResults={this.state.searchResults}
              category={this.state.category}
              subCategory={this.state.subCategory}
              selectChar={this.props.selectChar}
            />
          </Col>
          <Col sm={5}>
            <input
              type="text"
              ref="searchInput"
              placeholder="Search for a symbol, e.g. omega"
              value={this.state.searchQuery}
              onChange={this.handleQueryChange}
            />
            {this.props.char != null ? <FullCharPreview char={this.props.char} /> : undefined}
          </Col>
        </Row>
      </div>
    );
  }
}

export default UnicodeCharacterChooser;
